import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Header from "./Header";
import Result from "./Result";
import mgmtVariantOptions from "src/services/mgmtVariantOptions";

const VariantOptionsList = () => {
  const [variantOptions, setVariantOptions] = useState([]);

  const businessInfo = useSelector(
    (state) => state?.app?.businessInfo
  );

  const customerId = businessInfo?.customerId;

  useEffect(() => {
    const fetchVariantOptions = async () => {
      if (!customerId) {
        return;
      }

      try {
        const response =
          await mgmtVariantOptions.getAllVariantOptions(customerId);

        setVariantOptions(
          response?.payload?.variantOptions || []
        );
      } catch (error) {
        console.error("Error fetching variant options:", error);
        setVariantOptions([]);
      }
    };

    fetchVariantOptions();
  }, [customerId]);

  if (!customerId) {
    return null;
  }

  return (
    <>
      <Header />
      <Result variantOptions={variantOptions} />
    </>
  );
};

export default VariantOptionsList;